module.exports = "<div class=\"row\">\n  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n    <component-handler class=\"page\" loaded=\"bundleInfoCtrl.loaded\" error=\"bundleInfoCtrl.error\"> </component-handler>\n  </div>\n</div>\n<div class=\"row\" ng-if=\"bundleInfoCtrl.loaded && !bundleInfoCtrl.error.status\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-lg\">\n      <h4>DESCRIPTION</h4>\n      <p wysiwyg-content=\"bundleInfoCtrl.ngModel.description\"></p>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bundleInfo/template.html
// module id = 1286
// module chunks = 0